<script>
import BaseDetail from './base-detail'

export default {
  name: 'BaseDetailPopup',

  extends: BaseDetail,

  data () {
    return {
      autoLoad: false // Không tự động load do các thành phần trong dialod lúc này chưa mount
    }
  },

  mounted () {
    var me = this

    me.$nextTick(() => {
      // eslint-disable-next-line no-unused-expressions
      me.$refs.dialog?.setBeforeCloseFunc(this.close)
    })
  },

  methods: {
    /**
     * @description Hiển thị popup
     * @author PHNam
     */
    open () {
      var me = this
      var dialog = me.$refs.dialog

      dialog.open() // = true
      dialog.$nextTick(() => {
        me.afterOpenDialog()
      })
    },

    /**
     * @description Thêm listener cho popup
     * @param {*} event
     * @param {*} callback
     * @author PHNam
     */
    addListerner (event, callback) {
      this.$refs.dialog.addListener(event, callback)
    },

    /**
     * @description Gỡ listener cho popup
     * @param {*} event
     * @param {*} callback
     * @author PHNam
     */
    removeListerner (event, callback) {
      this.$refs.dialog.addListener(event, callback)
    },

    /**
     * @description Đóng popup
     * @param hide Hàm đóng
     * @author PHNam
     */
    async close (hide) {
      const me = this
      const canClose = !me.isCheckChange || !me.checkChange()

      if (canClose) {
        hide()
      } else {
        me.warningChange(hide)
      }
    },

    /**
     * @description Thực hiện đóng popup đi
     * @author PHNam
     */
    doAfterNotify (isSuccess) {
      var me = this

      if (isSuccess) {
        me.doClose()
      }
    },

    /**
     * @description Thực hiến ẩn popup
     * @author PHNam
     */
    doClose () {
      const dialog = this.$refs.dialog
      if (dialog && typeof dialog.close === 'function') {
        dialog.close()
      }
    },

    /**
     * @description Thực liên load form sau khi show popup
     * @author PHNam
     */
    afterOpenDialog () {
      this.initToolbar()
      this.loadForm()
    },

    /**
     * @description Xử lý toolbar button, thêm command close
     * @author PHNam
     */
    onToolbarItemClick (command, button) {
      const me = this
      const commandName = me.$enumeration.CommandName
      const isAdd = command === commandName.SaveAdd

      switch (command) {
        case commandName.SaveAdd:
        case commandName.Save:
          me.onSave(isAdd)
          break
        case commandName.Close:
          me.close(me.doClose)
          break
        default:
          me.onToolbarItemCustomClick(command, button)
      }
    }
  }
}
</script>
